import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, reduxForm} from 'redux-form';
import {Badge, Button, ButtonToolbar, Col, Form, Glyphicon, Panel, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {BirthDateField, CheckboxField, formatDate, RadioField, scrollToErrors, SelectField, TextField, withStopPropagation} from '../form/form';
import type {TWrappers} from "../../utils/index";
import {addNestedError, createOptions, Date, ModalWrappers, PanelWrappers, resolveApiResult, validateAddress} from "../../utils/index";
import {newsletterOptions, PartyRole, PartyStatus, partyStatusOptions, PartyText as t, PartyType, PartyVariant} from "../../utils/enums";
import {handleItemSave, ItemContext, onItemSaveSuccess} from "../dog/helpers";
import {connect} from "react-redux";
import {loadParty, saveParty} from "../../actions/parties";
import {showMessage} from "../../actions";
import {defaultState} from "../../reducers/entity";

const validate = (values, props) => {
	const errors = {};

	let legalNeeded = false;
	if (PartyType.PO === values.partyType) {
		if (!values.companyName) {
			errors.companyName = 'Zadejte prosím název'
		}
		legalNeeded = true;

	} else {
		const isWalker = values.partyRoles && values.partyRoles.indexOf(PartyRole.WALKER) >= 0;

		if (props.variant !== PartyVariant.ALT_PARTY) {
			if (!values.lastName) {
				errors.lastName = 'Zadejte prosím příjmení'
			}
			if (!values.firstName) {
				errors.firstName = 'Zadejte prosím jméno'
			}
		}

		if (isWalker || props.variant === PartyVariant.ALT_PARTY) {
			if (!values.phone) {
				errors.phone = 'Zadejte prosím telefon'

			} else if (!/^([+][0-9]{1,3})?([0-9]{9,})$/.test(values.phone.split(' ').join(''))) {
				errors.phone = 'Neplatný telefon'
			}
		}

		if (isWalker) {
			if (values.email && (values.email.indexOf('@') <= 0
				|| values.email.indexOf('.', values.email.indexOf('@')) <= 0
				|| values.email.lastIndexOf('.') >= values.email.length - 2
				|| values.email.length < 7)) {
				errors.email = 'Neplatný email'
			}

			if (values.isNewsletter !== true && values.isNewsletter !== false) {
				errors.isNewsletter = "Vyberte prosím"
			}

			if (!values.partyId && !values.isConfirmed) {
				errors.isConfirmed = "Potvďte prosím souhlas"
			}

			if (!values.birthDate) {
				errors.birthDate = 'Zadejte prosím datum narození'

				// } else if (values.birthDate.length < 4 || values.birthDate.length > 10 || !/([0-9]{1,2}\.[0-9]{1,2}\.)?(19|20)[0-9]{2}/.test(values.birthDate)) {
				// 	errors.birthDate = 'Datum není ve formátu DD.MM.RRRR'
				//
				// } else if (1 * values.birthDate.substr(-4) > 2018) {
				// 	errors.birthDate = 'Datum narození nesmí být v budoucnu'

			} else {
				legalNeeded = Date.getAge(values.birthDate) < 18;
			}
		}
		if (values.birthDate) {
			legalNeeded = Date.getAge(values.birthDate) < 18;
		}
	}

	validateAddress(values, 'permAddress', errors, !(props && (props.variant === PartyVariant.INTAKE_PARTY || props.variant === PartyVariant.ALT_PARTY)));
	validateAddress(values, 'mailAddress', errors, false);
	if (legalNeeded) {
		const legalParty = values.legalParty || {};
		if (!legalParty.lastName) {
			addNestedError(errors, 'legalParty', 'lastName', 'Zadejte prosím příjmení');
		}
		if (!legalParty.firstName) {
			addNestedError(errors, 'legalParty', 'firstName', 'Zadejte prosím jméno');
		}
		if (!legalParty.phone) {
			addNestedError(errors, 'legalParty', 'phone', 'Zadejte prosím telefon');
		}
		if (legalParty.email && (legalParty.email.indexOf('@') <= 0
			|| legalParty.email.indexOf('.', legalParty.email.indexOf('@')) <= 0
			|| legalParty.email.lastIndexOf('.') >= legalParty.email.length - 2
			|| legalParty.email.length < 7)) {
			addNestedError(errors, 'legalParty', 'email', 'Neplatný email');
		}
		const errors2 = {};
		validateAddress(legalParty, 'permAddress', errors2, !(PartyType.PO === values.partyType));
		if (errors2['permAddress']) {
			addNestedError(errors, 'legalParty', 'permAddress', errors2['permAddress']);
		}
	}

	return errors
};

const textual = (item) => {
	let name;
	if (item.partyType === PartyType.PO) {
		name = item.companyName + (item.companyNumber ? ' ' + item.companyNumber : '');

	} else if (item.firstName || item.lastName) {
		name = (item.firstName || '') + ' ' + (item.lastName || '');

	} else if (item.phone) {
		name = item.phone;
	}
	if (!name) {
		return 'ID ' + item.partyId;
	}

	return name + ' (ID ' + item.partyId + ')';
}

class PartyForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			partyType: null,
			legalNeeded: false
		};

		this.handlePartyTypeChange = this.handlePartyTypeChange.bind(this);
		this.handleBirthDateChange = this.handleBirthDateChange.bind(this);

		this.ctx = {
			itemTag: t[props.variant].tag,
			itemKeyName: 'partyId',
			saveItem: this.props.saveParty,
			showMessage: this.props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, {modal: props.modal})
		}
	}

	componentWillMount() {
		this.loadParty(this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.party.partyId !== this.props.party.partyId) {
			this.loadParty(nextProps);
		}
	}

	loadParty(props) {
		const {party} = props;
		if (party.partyId) {
			this.props.loadParty(party.partyId).then((json) => {
				if (resolveApiResult(json)) {
					this.syncEnumsAndState(json.response.data);
				}
			});
		} else {
			this.syncEnumsAndState(party);
		}
	}

	syncEnumsAndState(party) {
		this.handlePartyTypeChange(party.partyType);
		if (PartyType.FO === party.partyType) {
			this.handleBirthDateChange(party.birthDate)
		}
	}

	handlePartyTypeChange(partyType) {
		this.setState({partyType: partyType});
	}

	handleBirthDateChange(birthDate) {
		this.setState({legalNeeded: birthDate && Date.getAge(birthDate) < 18});
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;
		const isModal = !!modal;

		const Wrappers = isModal ? ModalWrappers : PanelWrappers;

		return <Wrappers.Wrapper modal={modal}>
			{!item || isFetchingItem ? null : this.renderForm(Wrappers)}
		</Wrappers.Wrapper>
	}

	renderForm(Wrappers: TWrappers) {
		const {initialValues, submitting, variant, modal} = this.props;
		const {legalNeeded, partyType} = this.state;
		const isModal = !!modal;

		const handleSubmit = (event) => {
			const {handleSubmit} = this.props;
			return withStopPropagation(handleSubmit((values) => {
				if (!legalNeeded && values.partyType !== PartyType.PO) {
					values.legalParty = undefined;
				} else if (!values.partyId && values.legalParty) {
					values.legalParty.partyType = PartyType.FO;
					values.legalParty.partyRoles = [PartyRole.LEGAL];
					values.legalParty.status = PartyStatus.ACTIVE;
				}
				return handleItemSave(this.ctx, values);
			}))(event);
		}

		const hasConsent = !initialValues.partyId && initialValues.partyRoles.indexOf(PartyRole.WALKER) >= 0;
		const hasNewsletter = !hasConsent && partyType === PartyType.FO;
		const hasStatus = !isModal && initialValues.partyId && initialValues.partyRoles.indexOf(PartyRole.WALKER) >= 0;

		return <Form horizontal onSubmit={handleSubmit} className="detail">
			<Row>
				<Col lg={isModal ? 12 : 8} lgOffset={isModal ? 0 : 2}>
					<Panel>
						<Wrappers.Header>
							{initialValues.partyId
								? <span>{t[variant].titleExisting} <Badge className="pull-right">{initialValues.partyId}</Badge></span>
								: <span>{t[variant].titleNew}</span>}
						</Wrappers.Header>
						<Wrappers.Body>
							{!isModal && !initialValues.partyId && variant !== PartyVariant.WALKER && <Row>
								<Col sm={4}>
									<Field label="Pr. forma" name="partyType" options={createOptions(PartyType)} component={RadioField} sizes={[5, 6]}
										onChangeHook={this.handlePartyTypeChange}/>
								</Col>
							</Row>}
							{partyType === PartyType.FO && <Row>
								<Col sm={5}>
									<Field label={'Jméno'} name="firstName" type='text' component={TextField} maxLength="100"/>
									<Field label={'Příjmení'} name="lastName" type='text' component={TextField} maxLength="100"/>
									<Field label="Dat. nar." title={"Datum narození"} name="birthDate" type="text" maxDate={Date.today()}
										onChangeHook={this.handleBirthDateChange}
										component={BirthDateField} maxLength="12" format={formatDate}/>
								</Col>
								<Col sm={7}>
									<Field label="Email" name="email" type='text' component={TextField} sizes={[2, 8]} maxLength="100" feedbackSuccess/>
									<Field label="Telefon" name="phone" type='text' component={TextField} sizes={[2, 5]} maxLength="20"/>
								</Col>
							</Row>}
							{partyType === PartyType.PO && <Row>
								<Col sm={5}>
									<Field label={'Název'} name="companyName" type='text' component={TextField} maxLength="100"/>
									<Field label={'IČ'} name="companyNumber" type='text' component={TextField} maxLength="20"/>
								</Col>
							</Row>}
							{!!partyType && <Row>
								<h5 className="divider">{partyType === PartyType.PO ? 'Adresa sídla' : 'Adresa trvalého bydliště'}</h5>
								<Col sm={5}>
									<Field label={'Ulice'} name="permAddress[street]" type='text' component={TextField} maxLength="100"/>
								</Col>
								<Col sm={7}>
									<Row>
										<Col sm={8}>
											<Field label={'Město'} name="permAddress[city]" type='text' sizes={[3, 9]} component={TextField} maxLength="100"/>
										</Col>
										<Col sm={4}>
											<Field label={'PSČ'} name="permAddress[zip]" type='text' sizes={[3, 9]} component={TextField} maxLength="6"/>
										</Col>
									</Row>
								</Col>
							</Row>}
							{partyType === PartyType.FO && <Row>
								<h5 className="divider">Korespondenční adresa</h5>
								<Col sm={5}>
									<Field label={'Ulice'} name="mailAddress[street]" type='text' component={TextField} maxLength="100"/>
								</Col>
								<Col sm={7}>
									<Row>
										<Col sm={8}>
											<Field label={'Město'} name="mailAddress[city]" type='text' sizes={[3, 9]} component={TextField} maxLength="100"/>
										</Col>
										<Col sm={4}>
											<Field label={'PSČ'} name="mailAddress[zip]" type='text' sizes={[3, 9]} component={TextField} maxLength="6"/>
										</Col>
									</Row>
								</Col>
							</Row>}
							{hasNewsletter &&
								<Row className="divider">
									<Col sm={5}>
										<Field label="Marketingový souhlas" name="isNewsletter"
											options={newsletterOptions} component={RadioField} sizes={[4, 8]}/>
									</Col>
								</Row>}
							{hasStatus &&
								<Row>
									<Col sm={5}>
										<Field label="Stav" name="status" type="select" component={SelectField} options={partyStatusOptions}/>
									</Col>
								</Row>}
						</Wrappers.Body>
					</Panel>
					{(legalNeeded || partyType === PartyType.PO) && <Panel>
						<Panel.Heading>
							{partyType === PartyType.PO ? 'Zastupující osoba' : 'Zákonný zástupce'}
						</Panel.Heading>
						<Panel.Body>
							<Row>
								<Col sm={5}>
									<Field label={'Jméno'} name="legalParty[firstName]" type='text' component={TextField} maxLength="100"/>
									<Field label={'Příjmení'} name="legalParty[lastName]" type='text' component={TextField} maxLength="100"/>
								</Col>
								<Col sm={7}>
									<Field label="Telefon" name="legalParty[phone]" type='text' component={TextField} sizes={[2, 6]} maxLength="20"/>
									<Field label="Email" name="legalParty[email]" type='text' component={TextField} sizes={[2, 8]} maxLength="100" feedbackSuccess/>
								</Col>
							</Row>
							<Row>
								<h5 className="divider">Adresa trvalého bydliště</h5>
								<Col sm={5}>
									<Field label={'Ulice'} name="legalParty[permAddress][street]" type='text' component={TextField} maxLength="100"/>
								</Col>
								<Col sm={7}>
									<Row>
										<Col sm={8}>
											<Field label={'Město'} name="legalParty[permAddress][city]" type='text' sizes={[3, 9]} component={TextField} maxLength="100"/>
										</Col>
										<Col sm={4}>
											<Field label={'PSČ'} name="legalParty[permAddress][zip]" type='text' sizes={[3, 9]} component={TextField} maxLength="6"/>
										</Col>
									</Row>
								</Col>
							</Row>
						</Panel.Body>
					</Panel>}
				</Col>
				{hasConsent && <Col lg={8} lgOffset={2}>
					<Panel>
						<Panel.Heading>
							Závazné podmínky smlouvy a pravidla výpůjčky zvířete
						</Panel.Heading>
						<Panel.Body>
							<p>
								Vypůjčitel prohlašuje, že vyplněním požadovaných údajů a jejich potvrzením se zavazuje k dodržování následujících pravidel pro
								venčení a jiné interakci se zvířetem umístěném v útulku. V případě porušení následujících pravidel odpovídá vypůjčitel za veškerou
								škodu způsobenou útulku, jakož i třetím osobám, a to i za škodu způsobenou vypůjčeným zvířetem.
							</p>
							<p>
								1) Zvíře je možné zapůjčit pouze osobě starší 18-ti let, osobě mladší 15-ti let pouze v doprovodu staršího 18-ti let a osobám
								ve věku 15-18 let pouze s písemným souhlasem rodičů či jiného zákonného zástupce.
							</p>
							<p>
								2) Zájemce o venčení – vypůjčitel se musí před vypůjčením zvířete prokázat osobním dokladem (např. občanským
								průkazem) pracovníku útulku a tyto údaje poskytnout ke zpracování ve zvláštním seznamu. Osobní údaje slouží výhradně
								pro evidenci organizaci a pro jeho pracovníky. Pracovníci nesmí s osobními údaji nakládat tak, aby se s nimi seznámily
								třetí osoby s výjimkou, kterou určují právní předpisy.
							</p>
							<p>
								3) Zapůjčovány jsou pouze zvířata - psi k tomu, dle uvážení pracovníka útulku, vhodní. Pracovník je povinen seznámit
								zájemce se stavem a povahou psa a důrazně poučit, jak se psem zacházet.
							</p>
							<p>
								4) Zapůjčený pes musí mít obojek, být na vodítku a v případě nutnosti mít nasazen košík.
							</p>
							<p>
								5) Pes musí být stále pod kontrolou, nesmí být z vodítka vypuštěn, v případě, že je opatřen náhubkem, nesmí mu být
								náhubek sundán.
							</p>
							<p>
								6) Venčení probíhá pouze v lokalitách a jen v době určené pracovníkem útulku.
							</p>
							<p>
								7) Vypůjčitel nese plnou odpovědnost za svěřené zvíře a odpovídá za všechny možné škody jim způsobené jak útulku, třetím
								osobám, cizímu majetku, tak sobě a zavazuje se případné škody uhradit.
							</p>
							<p>
								8) Vypůjčitel byl řádně poučen o bezpečnosti pohybu v areálu útulku, o manipulaci se zvířetem a svým podpisem a
								poučením pro dobrovolníky a zavazuje se dodržovat veškerá pravidla z nich vyplývajících, která se stávají součástí
								smlouvy o výpůjčce.
							</p>
							<p>
								Vyplněním požadovaných údajů vypůjčitel prohlašuje, že si řádně přečetl uvedené podmínky a byl poučen o veškerých právech a
								povinnostech, jakož i zásadami zacházení se zvířetem .
							</p>
							<p>
								Beru na vědomí, že s ohledem na uzavření smlouvy jsou za účelem plnění práv a povinností, jakož i za účelem ochrany
								oprávněných zájmů provozovatele útulku a ochrany zvířat, zpracovávány poskytnuté osobní údaje. Informace o zpracování
								osobních údajů byly poskytnuty při uzavírání smlouvy a jsou kdykoliv k dispozici u provozovatele útulku.
							</p>

							<div className={"newsletter-box"}>
								<Field label="Souhlasím se zpracováním osobních údajů pro účely zasílání marketingových sdělení a novinek v útulku Dogpoint." name="isNewsletter"
									options={newsletterOptions} component={RadioField} sizes={[8, 3]}/>
							</div>
							<div className={"text-center"}>
								<Field label="Vše jsem si řádně přečetl/a, byl/a jsem poučen/a a souhlasím se všemi body." name="isConfirmed" type='checkbox' component={CheckboxField}/>
							</div>
						</Panel.Body>
					</Panel>
				</Col>}
			</Row>
			<Wrappers.Footer>
				<ButtonToolbar className="text-center">
					{isModal
						? <Button onClick={modal.onHide} disabled={submitting}>Storno</Button>
						: <Link to={{pathname: "/" + (initialValues.partyId ? "vencitele/" + initialValues.partyId : "")}}
							className="btn btn-default"><Glyphicon glyph="remove"/> Storno</Link>}
					<Button bsStyle="success" type="submit" disabled={submitting}><Glyphicon glyph="ok"/> {initialValues.partyId
						? "Uložit změny"
						: t[variant].saveNew}</Button>
				</ButtonToolbar>
			</Wrappers.Footer>
		</Form>;
	}
}

PartyForm = reduxForm({
	validate,
	enableReinitialize: true,
	onSubmitFail: scrollToErrors
})(PartyForm);

const mapStateToProps = (state, ownProps) => {
	const {
		entities: {parties},
		enums,
		session
	} = state;

	const form = state.form[ownProps.form];
	const {party} = ownProps;

	const entity = party.partyId && parties[party.partyId]
		? parties[party.partyId]
		: {
			...defaultState,
			item: (form || {}).initial || (party.partyId ? null : party)
		};

	return {
		entity,
		initialValues: entity.item,
		enums,
		session
	}
}

PartyForm.propTypes = {
	party: PropTypes.object.isRequired,
	variant: PropTypes.string.isRequired,
	loadParty: PropTypes.func.isRequired,
	saveParty: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadParty,
	saveParty,
	showMessage
})(PartyForm)



// WEBPACK FOOTER //
// ./src/components/party/PartyForm.js